export default __webpack_public_path__ + "media/images/home/slide_hishochi_2026_lg-0610c79b9ca546bd102f1f0055eff025.jpg";